import React, { useCallback, useEffect, useState } from "react";

import moment from "moment";

import Profile from "../../assets/images/profile.png";

import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import { Badge } from "react-bootstrap";

import AuthService from "../../services/auth.service";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Form } from "react-bootstrap";

import Select from "react-select";
import HolidayShiftService from "../../services/holidayshift.service";
import { useStateContext } from "../../contexts/ContextProvider";
import { Flex } from "antd";

import { IoMdClose } from "react-icons/io";

const ApplyCompoff = ({ applyModal, setApplyModal, fetchCompoffData }) => {
  const user = AuthService.getCurrentUser();

  const [totalWorkingHours, setTotalWorkingHours] = useState("");

  const [validated, setValidated] = useState(false);

  const initialData = {
    project: "",
    module: "",
    assignee: "",
    desc: "",
    duration: "0",
  };

  const initialData2 = {
    date: "",
    formatedDate: "",
    fromTime: "",
    toTime: "",
    workinghrs: "",
  };

  const [details, setDetails] = useState(initialData);
  const [details2, setDetails2] = useState(initialData2);

  const [dates, setDates] = useState([]);

  const { employees, getNameInitials } = useStateContext();

  const [empOption, setEmpOption] = useState({});

  useEffect(() => {
    const filteredEmployees = employees.map((item) => ({
      label: item.name,
      value: item.empId,
    }));
    setEmpOption(filteredEmployees);
  }, [employees]);


  const [projects, setProjects] = useState([]);

  // const currentDate = new Date();

  const fetchProjects = useCallback(() => {
    HolidayShiftService.getListofProjects().then((resp) => {
      if (resp.data) {
        const projectOptions = resp.data.map((item) => ({
          value: item.projectid,
          label: item.projectname,
        }));
        setProjects(projectOptions);
      }
    }).catch(e => console.log(e));
  }, []);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  const calculateTimeDifference = (time1, time2) => {
    // console.log(time1, time2);
    time1 = time1 && time1.split(":");
    time2 = time2 && time2.split(":");

    var startDate = new Date(0, 0, 0, time1[0], time1[1], 0);
    var endDate = new Date(0, 0, 0, time2[0], time2[1], 0);

    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);

    if (hours < 0) {
      hours = hours + 24;
    }

    return (
      (hours <= 9 ? "0" : "") +
      hours +
      ":" +
      (minutes <= 9 ? "0" : "") +
      minutes
    );
  };

  const [date, setDate] = useState();

  const handleDateChange = (e) => {
    setDate(e.value);
    setDetails2((prevState) => ({
      ...prevState,
      date: moment(new Date(e.value)).format("YYYY-MM-DD"),
      formatedDate: moment(new Date(e.value)).format("D MMM YYYY"),
    }));
  };

  const handleSelect = (e) => {
    setDetails((prevState) => ({
      ...prevState,
      project: e,
    }));
  };

  const handleSelectEmp = (e) => {
    setDetails((prevState) => ({
      ...prevState,
      assignee: e,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleInputChange2 = (e) => {
    const { name, value } = e.target;

    if (name === "fromTime") {
      const hours = calculateTimeDifference(value, details2.toTime);
      setDetails2((prevState) => ({
        ...prevState,
        fromTime: value,
        workinghrs: hours,
      }));
    } else if (name === "toTime") {
      const hours = calculateTimeDifference(details2.fromTime, value);
      setDetails2((prevState) => ({
        ...prevState,
        toTime: value,
        workinghrs: hours,
      }));
    }
  };

  const hideLeaveModal = (e) => {
    e.preventDefault();
    setApplyModal(false);
  };

  const isValidHours = (hours) => {
    if (typeof hours !== "string") return false;
    const parts = hours.split(":");
    if (parts.length !== 2) return false;
    const [hoursPart, minutesPart] = parts;
    return `${!isNaN(hoursPart) && hoursPart}:${
      !isNaN(minutesPart) && minutesPart
    }`;
  };

  useEffect(() => {
    let totalMinutes = 0;

    for (const time of dates) {
      const workinghrs = time.workinghrs;
      const [hours, minutes] = workinghrs.split(":").map(Number);
      totalMinutes += hours * 60 + minutes;
    }
    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;

    const totalWorkingHours =
      (totalHours <= 9 ? "0" : "") +
      totalHours +
      ":" +
      (remainingMinutes <= 9 ? "0" : "") +
      remainingMinutes;

    setTotalWorkingHours(totalWorkingHours);
  }, [dates]);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    if (form.checkValidity() === false || dates.length === 0) {
      setValidated(true);
      toast.warn("* Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    const data = {
      empid: user && user.empid,
      projectid: details.project.value,
      module: details.module,
      description: details.desc,
      assignee: details.assignee.value,
      workduration: dates.length.toString(),
      requestid: "0",
      reqdetails: dates.map((item) => ({
        rdate: item.date,
        fromtime: item.fromTime,
        totime: item.toTime,
      })),
    };

    // console.log(data);

    HolidayShiftService.addHolidayShift(data)
      .then((resp) => {
        if (resp.data) {
          setDetails(initialData);
          setDates([]);
          setDetails2(initialData2);
          fetchCompoffData();
          toast.success("Holiday Shift Added Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            onClose: () => setApplyModal(false),
          });
        }
      })
      .catch((e) => console.log(e));
  };

  const addRow = () => {
    // console.log(Object.values(details2).every((value) => value !== ""));
    if (Object.values(details2).every((value) => value !== "")) {
      setDates((prevState) => [...prevState, details2]);
      setDetails2(initialData2);
    } else {
      toast.warn("* Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const removeRow = (date) => {
    // console.log(date);
    const filteredData = dates.filter((item) => item.date !== date);
    // console.log(filteredData);
    setDates(filteredData);
  };

  return (
    <>
      <div
        className={`${
          applyModal ? "applyLeaveModal visible" : "applyLeaveModal hidden"
        }`}
      >
        <div className="filter-flex">
          <ToastContainer />
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="sort-list">
              <div className="leaveModalHeading mb-lg-5 mb-4">
                <Flex
                  className="mb-lg-5 mb-4"
                  justify="space-between"
                  align="center"
                >
                  <Flex className="left-flex" gap={10} align="center">
                    <div className="heading">
                      <span>Applying for Holiday Shift </span>
                    </div>
                  </Flex>
                  <div className="close">
                    <IoMdClose
                      size={30}
                      color="#4E465E"
                      onClick={() => setApplyModal(false)}
                    />
                  </div>
                </Flex>

                <div className="row">
                  <div className="col-lg-6">
                    <div className="left-flex">
                      <div className="profile">
                        {user && user.profile ? (
                          <img src={Profile} width={50} alt="" />
                        ) : (
                          <>
                            <div className="circle">
                              <span>
                                {getNameInitials(user && user.userName)}
                              </span>
                            </div>
                          </>
                        )}

                        <div className="profile-info">
                          <span className="name">{user && user.userName}</span>
                          <span className="desig">
                            {user && user.designation}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="balance">
                      <div className="right">
                        <Flex gap={10}>
                          <div className="flex">
                            <span>Applied For:</span>
                            <span className="count">
                              {Array.isArray(dates) && dates.length} Days
                            </span>
                          </div>
                          <div className="flex">
                            <span>Work Hours:</span>
                            <span className="count">
                              {isValidHours(totalWorkingHours)} Hrs
                            </span>
                          </div>
                        </Flex>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="leaveModalBody">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="mb-3 calendar-relative">
                      <label htmlFor="leaveType" className="form-label">
                        Project *
                      </label>
                      <Select
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            height: "45px",
                            fontSize: "16px",
                            lineHeight: "20px",
                            fontWeight: "500",
                            border: "1px solid rgba(210, 205, 218, 1)",
                          }),
                          option: (baseStyles, { isFocused, isSelected }) => ({
                            ...baseStyles,
                            fontSize: "16px",
                            lineHeight: "20px",
                            fontWeight: "500",
                            borderRadius: "4px",
                            backgroundColor: isSelected
                              ? "rgba(177, 206, 251, 1)"
                              : isFocused
                                ? "rgba(177, 206, 251, 1)"
                                : "rgba(255, 255, 255, 1)",
                            color: isSelected
                              ? "rgba(78, 70, 94, 1)"
                              : isFocused
                                ? "rgba(78, 70, 94, 1)"
                                : "rgba(78, 70, 94, 1)",
                          }),
                          menu: (baseStyles, state) => ({
                            ...baseStyles,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                          }),
                        }}
                        options={projects}
                        onChange={handleSelect}
                        value={details.project}
                        placeholder="Project name"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-5 ps-lg-0">
                    <div className="mb-3">
                      <label htmlFor="leaveType" className="form-label">
                        Module *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Module"
                        name="module"
                        value={details.module}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-7 ps-lg-0">
                    <div className="mb-3">
                      <label htmlFor="leaveType" className="form-label">
                        Assignee name *
                      </label>
                      <Select
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            height: "45px",
                            fontSize: "16px",
                            lineHeight: "20px",
                            fontWeight: "500",
                            border: "1px solid rgba(210, 205, 218, 1)",
                          }),
                          option: (baseStyles, { isFocused, isSelected }) => ({
                            ...baseStyles,
                            fontSize: "16px",
                            lineHeight: "20px",
                            fontWeight: "500",
                            borderRadius: "4px",
                            backgroundColor: isSelected
                              ? "rgba(177, 206, 251, 1)"
                              : isFocused
                                ? "rgba(177, 206, 251, 1)"
                                : "rgba(255, 255, 255, 1)",
                            color: isSelected
                              ? "rgba(78, 70, 94, 1)"
                              : isFocused
                                ? "rgba(78, 70, 94, 1)"
                                : "rgba(78, 70, 94, 1)",
                          }),
                          menu: (baseStyles, state) => ({
                            ...baseStyles,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                          }),
                        }}
                        options={empOption}
                        onChange={handleSelectEmp}
                        value={details.assignee}
                        placeholder="Assignee name"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="mb-3 calendar-relative d-flex flex-column">
                      <label htmlFor="leaveType" className="form-label">
                        Date*
                      </label>
                      <Calendar
                        value={date}
                        onChange={handleDateChange}
                        view="date"
                        dateFormat="dd-mm-yy"
                        style={{ height: "45px" }}
                        showIcon
                        disabledDays={[1, 2, 3, 4, 5]}
                        selectOtherMonths
                      />
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="row">
                      <div className="col-lg-6 col-6 ps-lg-0">
                        <div className="mb-3 calendar-relative">
                          <label htmlFor="leaveType" className="form-label">
                            From Time *
                          </label>
                          <input
                            type="time"
                            className="form-control"
                            name="fromTime"
                            value={details2.fromTime}
                            onChange={handleInputChange2}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-6 ps-lg-0">
                        <div className="mb-3">
                          <label htmlFor="leaveType" className="form-label">
                            To Time *
                          </label>
                          <input
                            type="time"
                            className="form-control"
                            name="toTime"
                            value={details2.toTime}
                            onChange={handleInputChange2}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 col-6 ps-lg-0">
                    <div className="mb-3 calendar-relative">
                      <label htmlFor="leaveType" className="form-label">
                        Working Hours
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="workinghrs"
                        value={details2.workinghrs}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-lg-1 col-6 ps-lg-0">
                    <div className="addRow">
                      <button type="button" onClick={addRow}>
                        <div className="circle">
                          <svg
                            width="48"
                            height="48"
                            viewBox="0 0 60 61"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              opacity="0.5"
                              d="M55 30.5C55 44.307 43.807 55.5 30 55.5C16.1929 55.5 5 44.307 5 30.5C5 16.6929 16.1929 5.5 30 5.5C43.807 5.5 55 16.6929 55 30.5Z"
                              fill="#0B60EA"
                            />
                            <path
                              d="M31.875 23C31.875 21.9645 31.0355 21.125 30 21.125C28.9645 21.125 28.125 21.9645 28.125 23V28.625H22.5C21.4645 28.625 20.625 29.4645 20.625 30.5C20.625 31.5355 21.4645 32.375 22.5 32.375H28.125V38C28.125 39.0355 28.9645 39.875 30 39.875C31.0355 39.875 31.875 39.0355 31.875 38V32.375H37.5C38.5355 32.375 39.375 31.5355 39.375 30.5C39.375 29.4645 38.5355 28.625 37.5 28.625H31.875V23Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>

                {Array.isArray(dates)
                  ? dates.length > 0 && (
                      <div className="">
                        <label htmlFor="leaveType" className="form-label">
                          Selected Dates
                        </label>
                      </div>
                    )
                  : null}

                {Array.isArray(dates)
                  ? dates.map((item) => {
                      return (
                        <div className="row">
                          <div className="col-lg-4">
                            <div className="mb-3 calendar-relative">
                              <label htmlFor="leaveType" className="form-label">
                                Date*
                              </label>
                              <div className="date-input">
                                <span>{item.formatedDate}</span>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 col-4 ps-lg-0">
                            <div className="mb-3 calendar-relative">
                              <label htmlFor="leaveType" className="form-label">
                                From Time
                              </label>
                              <input
                                type="time"
                                className="form-control"
                                name="fromTime"
                                value={item.fromTime}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-lg-2 col-4 ps-lg-0">
                            <div className="mb-3">
                              <label htmlFor="leaveType" className="form-label">
                                To Time
                              </label>
                              <input
                                type="time"
                                className="form-control"
                                name="toTime"
                                value={item.toTime}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-lg-3 col-4 ps-lg-0">
                            <div className="mb-3 calendar-relative">
                              <label htmlFor="leaveType" className="form-label">
                                Hours
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="fromTime"
                                value={item.workinghrs}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-lg-1 ps-lg-0">
                            <div className="addRow">
                              <button
                                type="button"
                                onClick={(e) => {
                                  removeRow(item.date);
                                }}
                              >
                                <div className="circle">
                                  <svg
                                    width="48"
                                    height="48"
                                    viewBox="0 0 60 60"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clip-rule="evenodd"
                                      d="M55 30C55 43.807 43.807 55 30 55C16.1929 55 5 43.807 5 30C5 16.1929 16.1929 5 30 5C43.807 5 55 16.1929 55 30ZM39.375 30C39.375 31.0355 38.5355 31.875 37.5 31.875H22.5C21.4645 31.875 20.625 31.0355 20.625 30C20.625 28.9645 21.4645 28.125 22.5 28.125H37.5C38.5355 28.125 39.375 28.9645 39.375 30Z"
                                      fill="#8D93A5"
                                    />
                                  </svg>
                                </div>
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : null}

                <div className="row">
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label htmlFor="leaveType" className="form-label">
                        Description
                      </label>
                      <textarea
                        className="form-control"
                        name="desc"
                        value={details.desc}
                        onChange={handleInputChange}
                      ></textarea>
                      <Badge className="mt-3" bg="success">
                        {details.desc && details.desc.length}
                      </Badge>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="sort-action">
              <button className="btn btn-reset" onClick={hideLeaveModal}>
                Cancel
              </button>
              <button className="btn btn-apply">Apply</button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default ApplyCompoff;
